import { useEffect, useRef } from "react";

// Mini-oscilloscopio ("specchietto") affianco al pannello: disegna una forma d'onda
// (array di ampiezze 0..1) come UNA linea bianca spessa su sfondo del colore del
// pannello. Niente griglie, assi o altre indicazioni. Formato ~16:9 (dal CSS).
// Il calcolo della forma sta in scopeEngines.js; qui solo il rendering su canvas.
export default function BlackwaveScope({ data, className, ariaLabel }) {
  const canvasRef = useRef(null);
  const dataRef = useRef(data);
  dataRef.current = data;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const draw = () => {
      const d = dataRef.current;
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      const w = Math.max(2, Math.round(rect.width * dpr));
      const h = Math.max(2, Math.round(rect.height * dpr));
      if (canvas.width !== w) canvas.width = w;
      if (canvas.height !== h) canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, w, h);
      if (!d || d.length < 2) return;

      // padding orizzontale piccolo, VERTICALE piu' ampio: lascia spazio in alto e in
      // basso per i testi (tempi sopra, nome sotto), cosi' la linea non li tocca.
      const padX = Math.round(6 * dpr);
      const padY = Math.round(17 * dpr);
      const iw = w - 2 * padX;
      const ih = h - 2 * padY;
      ctx.strokeStyle = "#000000"; // nero come il contenuto dei pulsanti gialli
      ctx.lineWidth = Math.max(2, Math.round(2 * dpr)); // stesso spessore del bordo (2px)
      ctx.lineJoin = "miter"; // spigoli netti (square resta squadrata)
      ctx.lineCap = "butt";
      ctx.beginPath();
      for (let i = 0; i < d.length; i++) {
        const x = padX + (i / (d.length - 1)) * iw;
        const y = padY + (1 - Math.min(1, Math.max(0, d[i]))) * ih;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.stroke();
    };

    draw();
    const ro = new ResizeObserver(draw);
    ro.observe(canvas);
    return () => ro.disconnect();
  }, [data]);

  return <canvas ref={canvasRef} className={className} role="img" aria-label={ariaLabel} />;
}
